import { useQuery } from "react-query";
import { sortBy } from "lodash";

import useCurrentEnvironment from "@/hooks/use-environment";
import { queryClient } from "@/queryClient";
import { getEventDefs } from "@/util";
import { LoadedEventDefinition } from "@/types/global";

const EVENT_DEFS_KEY = "event_defs";

export function useEventDefs() {
  const environment = useCurrentEnvironment();

  return useQuery<LoadedEventDefinition[]>(
    [EVENT_DEFS_KEY, environment?.ID ?? ""],
    async () => {
      const response = await getEventDefs();
      return sortBy(response.event_defs, (ed) => ed.name.toLowerCase());
    },
    { enabled: !!environment?.ID },
  );
}

export function invalidateEventDefs() {
  return queryClient.invalidateQueries([EVENT_DEFS_KEY]);
}
